import { render, staticRenderFns } from "./RoleRow.vue?vue&type=template&id=18cf7aa0&"
import script from "./RoleRow.vue?vue&type=script&lang=js&"
export * from "./RoleRow.vue?vue&type=script&lang=js&"
import style0 from "./RoleRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports